'use strict';

const $ = require('dibs-jquery-shim');
const DC = require('bunsen/helpers/dibsConstants');
const {sessionStorage} = require('dibs-browser-storage');
const uri = require('bunsen/helpers/uri');

let notificationPromise;

/**
 * Helper for notification queue
 */
const notificationHelper = {
    notificationQueue: [
        require('./rules/pinterestConnectAccountsModalRule'),
        require('./rules/tradeTourRule'),
        require('./rules/netPriceRule'),
        require('./rules/requestItemHoldRule'),
        require('./rules/viewInvoiceCalloutRule'),
        require('./rules/saveItemCalloutRule'),
        require('./rules/saveToFolderCalloutRule'),
        require('./rules/loginPromptRule').loginPromptRule,
        require('./rules/chatRule'),
        require('./rules/followSearchCalloutRule'),
        require('./rules/followDealerCalloutRule'),
        require('./rules/mobileAdsRule'),
        require('./rules/abandonCheckoutRule.es'),
        require('./rules/favoritesCalloutsRules').default.selectItemsRule,
        require('./rules/favoritesCalloutsRules').default.rearrangeItemsRule,
        require('./rules/favoritesCalloutsRules').default.editFolderRule,
        require('./rules/searchBoxCalloutRule')
    ],

    firstInit: true,

    init(payload) {
        if (!this._isEnabled()) {
            return;
        }

        this.getPreferredType(payload)
            .catch(error => {
                console.error(`[notificationHelper#init]: ${error || 'promise fell through'}`);
            });

        if (this.firstInit) {
            $.subscribe(DC.pageEventPrefix + ':updated', () => this.init(Object.assign({ajax: true}, payload)));
            this.firstInit = false;
        }
    },

    /**
     * Gets preferred nofitication type
     * @return {promise}
     */
    getPreferredType(payload) {
        const {ajax} = payload;

        if (!notificationPromise || ajax) {
            notificationPromise = this._getPreferredType(Object.assign({index: 0}, payload));
        }

        return notificationPromise;
    },

    /**
     * Calls notification's rule.
     * Checks next notification if rule promise resolved with success being falsy.
     */
    _getPreferredType(payload) {
        const {index} = payload;
        const rule = this.notificationQueue[index];

        if (!rule || typeof rule !== 'function') {
            return this._checkNextNotification(payload);
        }

        return rule(payload).then(({success, type} = {}) => {
            if (success && type) {
                return type;
            } else if (success && !type) {
                throw new Error(`No notification type found. Rule index: ${index}`);
            }

            return this._checkNextNotification(payload);
        });
    },

    /**
     * Checks next notification (increase index).
     */
    _checkNextNotification(payload) {
        const {index} = payload;
        const isLastNotification = this._isLastNotification(index);

        if (isLastNotification) {
            return Promise.resolve('');
        } else {
            payload.index++;
            return this._getPreferredType(payload);
        }
    },

    /**
     * @return {boolean}
     */
    _isLastNotification(index) {
        return this.notificationQueue.length === index + 1;
    },

    /**
     * @return {boolean}
     */
    _isEnabled() {
        const queryKey = uri.parseUri(window.location.href).queryKey;
        const NO_NOTIF_KEY = 'no-notif';

        if (sessionStorage.getItem(NO_NOTIF_KEY) === true) {
            return false;
        }

        if (queryKey[NO_NOTIF_KEY] === 'true') {
            sessionStorage.setItem(NO_NOTIF_KEY, true);
            return false;
        }

        return true;
    }

};

module.exports = notificationHelper;



// WEBPACK FOOTER //
// ./assets/js/global/notifications/notificationHelper.es.js